import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoringLoader/tasksProgression/styles.scss';export default {
  "tasksProgression": "_tasksProgression_5og7q_1",
  "title": "_title_5og7q_5",
  "percentage": "_percentage_5og7q_11",
  "hours": "_hours_5og7q_17",
  "bar": "_bar_5og7q_22"
};